<template>
    <div v-if="message" class="view-payment-create-agent-payment-error">
        <div class="vpcape_left-side">
            <i class="icon svg-warning"></i>
        </div>
        <div class="vpcape_right-side">
            <p>{{ message }}</p>
        </div>
    </div>
</template>

<script setup lang="ts">
import LightPaymentPidResponseError from "@models/responses/light-payment-pid/LightPaymentPidResponseError";
import ModelAgent from "@models/agents/ModelAgent";
import {AccountError} from "@enums/ServerErrorCodes";
import {computed} from "vue";
import {useI18n} from "vue-i18n";
import UtilsService from "@/services/others/UtilsService";
import {PaymentFlow} from "@/targets/light/types";

interface IProps {
	paymentError: LightPaymentPidResponseError;
	agent: ModelAgent | null;
	amount: number;
	currency: "RUB" | "USD" | "USDT" | "KZT";
	selectedFlow: PaymentFlow | null;
}

const props = defineProps<IProps>();

const { t } = useI18n();

const utilsService = UtilsService.of();

const currencyFormatter = computed(() => utilsService.currencyFormatter(props.currency));

const formatedAmount = computed(() => {
	return currencyFormatter.value.format(props.amount);
});

const message = computed(() => {
	if (
		props.selectedFlow === null ||
		props.selectedFlow === PaymentFlow.AGENT
	) {
		return null;
	} else if (props.paymentError.code === AccountError.AgentsUnavailableForAmount) {
		return t(`payment-create-agents.errors.${AccountError.AgentsUnavailableForAmount}`);
	}

	return t('light-payment.create.agents.errors.10034', {
		amount: formatedAmount.value,
		method: t(`light-payment.create.tabs.classic-tab.${props.selectedFlow}.title`),
	});
});
</script>

<style lang="scss">
.view-payment-create-agent-payment-error {
    background: rgba(230, 151, 0, 0.1);
    border-radius: 12px;
    display: flex;
    color: rgba(207, 117, 41, 1);
    gap: 12px;
    padding: 12px;
    margin: 16px;

    .vpcape {
        &_left-side {
            display: flex;
            align-items: center;
        }
        p {
            @include text(14px, 400, #CF7529, 16.8px);
        }
    }
}
</style>
